import * as THREE from 'three';

export const createScene = () => {
  const scene = new THREE.Scene();
  scene.background = null; // 透明な背景
  return scene;
};